import {
  BarsLoader as RoseateAppLoader,
  Logo,
} from '@insight-health-ai/roseate/components';

const AppLoader = () => {
  return (
    <div className="loader-wrapper flex flex-col items-center justify-center w-[100vw] h-[100vh]">
      <Logo />
      <RoseateAppLoader size="md" />
    </div>
  );
};

export { AppLoader };
